const custom_profile_fields = {
    table: {
        add_button: 'เพิ่มฟิลด์โปรไฟล์',
        title: {
            field_label: 'ป้ายกำกับฟิลด์',
            type: 'ประเภท',
            user_data_key: 'คีย์ข้อมูลผู้ใช้',
        },
        placeholder: {
            title: 'เก็บข้อมูลโปรไฟล์ผู้ใช้',
            description: 'ปรับแต่งฟิลด์เพื่อเก็บข้อมูลโปรไฟล์ผู้ใช้เพิ่มเติมระหว่างการสมัครสมาชิก',
        },
    },
    type: {
        Text: 'ข้อความ',
        Number: 'ตัวเลข',
        Date: 'วันที่',
        Checkbox: 'กล่องกาเครื่องหมาย (บูลีน)',
        Select: 'ดรอปดาวน์ (เลือกได้ 1 ตัวเลือก)',
        Url: 'URL',
        Regex: 'นิพจน์ปกติ',
        Address: 'ที่อยู่ (แบบประกอบ)',
        Fullname: 'ชื่อ-นามสกุล (แบบประกอบ)',
    },
    modal: {
        title: 'เพิ่มฟิลด์โปรไฟล์',
        subtitle: 'ปรับแต่งฟิลด์เพื่อเก็บข้อมูลโปรไฟล์ผู้ใช้เพิ่มเติมระหว่างการสมัครสมาชิก',
        built_in_properties: 'ข้อมูลผู้ใช้พื้นฐาน',
        custom_properties: 'ข้อมูลผู้ใช้ที่กำหนดเอง',
        custom_data_field_name: 'คีย์ข้อมูลผู้ใช้',
        custom_data_field_input_placeholder: 'ป้อนคีย์ข้อมูลผู้ใช้ เช่น `myFavoriteFieldName`',
        custom_field: {
            title: 'ข้อมูลที่กำหนดเอง',
            description: 'คุณสมบัติเพิ่มเติมที่คุณสามารถกำหนดเองได้ตามความต้องการเฉพาะของแอปพลิเคชันของคุณ',
        },
        type_required: 'โปรดเลือกประเภทคุณสมบัติ',
        create_button: 'สร้างฟิลด์โปรไฟล์',
    },
    details: {
        page_title: 'รายละเอียดฟิลด์โปรไฟล์',
        back_to_sie: 'กลับไปที่ประสบการณ์การลงชื่อเข้าใช้',
        enter_field_name: 'กรอกชื่อฟิลด์โปรไฟล์',
        delete_description: 'การกระทำนี้ไม่สามารถย้อนกลับได้ คุณแน่ใจหรือไม่ว่าต้องการลบฟิลด์โปรไฟล์นี้?',
        field_deleted: 'ฟิลด์โปรไฟล์ {{name}} ถูกลบเรียบร้อยแล้ว',
        key: 'คีย์ข้อมูลผู้ใช้',
        field_name: 'ชื่อฟิลด์',
        field_type: 'ประเภทฟิลด์',
        settings: 'การตั้งค่า',
        settings_description: 'ปรับแต่งฟิลด์เพื่อเก็บข้อมูลโปรไฟล์ผู้ใช้เพิ่มเติมระหว่างการสมัครสมาชิก',
        address_format: 'รูปแบบที่อยู่',
        single_line_address: 'ที่อยู่บรรทัดเดียว',
        multi_line_address: 'ที่อยู่หลายบรรทัด (เช่น ถนน, อำเภอ, รัฐ, รหัสไปรษณีย์, ประเทศ)',
        components: 'องค์ประกอบ',
        components_tip: 'เลือกองค์ประกอบเพื่อนำมาประกอบเป็นฟิลด์แบบซับซ้อน',
        label: 'ป้ายกำกับฟิลด์',
        label_placeholder: 'ป้ายกำกับ',
        label_tip: 'ต้องการแปลภาษา? เพิ่มภาษาได้ที่ <a>ประสบการณ์การลงชื่อเข้าใช้ > เนื้อหา</a>',
        label_tooltip: 'ป้ายกำกับแบบลอยที่ใช้ระบุจุดประสงค์ของฟิลด์นี้ โดยจะปรากฏภายในช่องป้อนและลอยขึ้นเมื่อฟิลด์ถูกเลือกหรือมีค่า',
        placeholder: 'ตัวอย่างข้อความในฟิลด์',
        placeholder_placeholder: 'ตัวอย่างข้อความ',
        placeholder_tooltip: 'ตัวอย่างคำหรือรูปแบบที่แสดงในฟิลด์อินพุต มักแสดงหลังจากป้ายกำกับลอยขึ้น และควรเป็นข้อความสั้น ๆ (เช่น MM/DD/YYYY)',
        description: 'คำอธิบายฟิลด์',
        description_placeholder: 'คำอธิบาย',
        description_tooltip: 'ข้อความสนับสนุนที่แสดงใต้ช่องข้อมูลฟิลด์ ใช้สำหรับคำแนะนำเพิ่มเติมหรือข้อควรระวังด้านการเข้าถึง',
        options: 'ตัวเลือก',
        options_tip: 'กรอกแต่ละตัวเลือกในบรรทัดใหม่ ใช้ value:label (เช่น red:แดง) หรือใส่แค่ว่า value ก็ได้; ถ้าไม่มี label จะแสดง value เป็น label',
        options_placeholder: 'value1:label1\nvalue2:label2\nvalue3:label3',
        regex: 'นิพจน์ปกติ',
        regex_tip: 'กำหนดนิพจน์ปกติสำหรับตรวจสอบอินพุต',
        regex_placeholder: '^[a-zA-Z0-9]+$',
        date_format: 'รูปแบบวันที่',
        date_format_us: 'MM/dd/yyyy (ตัวอย่าง สหรัฐอเมริกา)',
        date_format_uk: 'dd/MM/yyyy (ตัวอย่าง สหราชอาณาจักรและยุโรป)',
        date_format_iso: 'yyyy-MM-dd (มาตรฐานสากล)',
        custom_date_format: 'รูปแบบวันที่ที่กำหนดเอง',
        custom_date_format_placeholder: 'ป้อนรูปแบบวันที่ เช่น "MM-dd-yyyy"',
        custom_date_format_tip: 'ดูรายละเอียดโทเคนรูปแบบในเอกสาร <a>date-fns</a>',
        input_length: 'ความยาวข้อมูลที่ป้อน',
        value_range: 'ช่วงของค่า',
        min: 'ค่าต่ำสุด',
        max: 'ค่าสูงสุด',
        default_value: 'ค่าตั้งต้น',
        checkbox_checked: 'เช็คไว้ (จริง)',
        checkbox_unchecked: 'ไม่เช็ค (เท็จ)',
        required: 'ต้องกรอก',
        required_description: 'เมื่อเปิดใช้งาน ฟิลด์นี้จะต้องให้ผู้ใช้กรอก หากปิดจะเป็นตัวเลือกเสริม',
    },
};
export default Object.freeze(custom_profile_fields);
